import { Element, Component, State, Prop, h } from '@stencil/core';
import { formatDate } from '@utils/utils';

@Component({
  tag: 'spw-card-content',
  styleUrl: 'spw-card-content.scss',
  shadow: true,
})
export class SpwCardContent {
  @Element() el: HTMLSpwCardContentElement;
  @State() hasImage: boolean;

  /** Tag spécifié dans la carte */
  @Prop() tag?: string;
  /** Date de publication */
  @Prop() date?: string;

  render() {
    return (
      <div class="spw-card-content">
        {this.tag && <span class="spw-card-content__tag">{this.tag}</span>}
        {this.date && (
          <time date-time={this.date} class="spw-card-content__date">
            {formatDate(this.date)}
          </time>
        )}
        <slot></slot>
      </div>
    );
  }
}
